import TechnographicsCard from "../criteria/TechnographicsCard";
import DemographicsCard from "../criteria/DemographicsCard";
import LocationCard from "../criteria/LocationCard";
import SubCohortsCard from "../criteria/SubCohortsCard";
import RealtimeSiteContentCard from "../criteria/RealtimeSiteContentCard";
import ContentConsumptionCard from "../criteria/ContentConsumptionCard";
import SyndicatedCard from "../criteria/SyndicatedCard";
import CustomUserDataCard from "../criteria/CustomUserDataCard";

/**
 * Check if a criteria is valid
 */
export const isValidCriteria = (criteria) => {
	if (!criteria || !criteria.type) return false;

	switch (criteria.type) {
		case "domains":
			return criteria.data?.domains?.length > 0;
		case "technographics":
			return TechnographicsCard.getSelectedCount(criteria.data) > 0;
		case "demographics":
			return DemographicsCard.getSelectedCount(criteria.data) > 0;
		case "location":
			return LocationCard.getSelectedCount(criteria.data) > 0;
		case "subCohorts":
			return SubCohortsCard.getSelectedCount(criteria.data) > 0;
		case "realtimeSiteContent":
			return RealtimeSiteContentCard.isValid(criteria.data);
		case "contentConsumption":
			return ContentConsumptionCard.isValid(criteria.data);
		case "syndicated":
			return SyndicatedCard.getSelectedCount(criteria.data) > 0;
		case "customUserData":
			return CustomUserDataCard.isValid(criteria.data);
		default:
			return Object.keys(criteria.data || {}).length > 0;
	}
};

/**
 * Check if a group has at least one valid criteria
 */
export const isValidGroup = (group) => group.some(isValidCriteria);
